import axios, { AxiosError } from "axios";
import { ApiConfig } from "./ApiConfig";

const base_url =
   window.location.hostname === "test.denuncias.lecosy.com.mx" ||
   window.location.hostname === "www.test.denuncias.lecosy.com.mx"
      ? "https://test.server.lecosy.com.mx"
      : process.env.NODE_ENV === "production"
      ? "https://server.lecosy.com.mx"
      : "http://localhost:8002";

const COMPANIES_ENDPOINT = "/companies";
const CLIENT_ENDPOINT = "/client";
const BRANCHES_ENDPOINT = "/branches";
const SUPPORTNOTIF_ENDPOINT = "/sup-notif";
const PLATFORM_ENDPOINT = "/platform-info";
const S3_ENDPOINT = "/s3";
export class UserClient extends ApiConfig {
   constructor() {
      super(base_url + "/api");
   }

   async getPlatformInfo(subName: string) {
      return await this.get(`${CLIENT_ENDPOINT}${PLATFORM_ENDPOINT}/${subName}`);
   }

   async getCompanyInfo(subName: string) {
      const { data } = await this.get(`${CLIENT_ENDPOINT}${COMPANIES_ENDPOINT}/${subName}`);
      if (!data) return undefined;
      return data;
   }
   async getCompanyBranches(companyId: string) {
      return await this.get(`${CLIENT_ENDPOINT}/channel${BRANCHES_ENDPOINT}/company/${companyId}`);
   }
   async createSupportNotification(
      company: string,
      email: string,
      body: string,
      isCR: boolean,
      name: string,
      phoneNumber?: string,
      reportNumber?: string
   ) {
      const reqBody = {
         company: company,
         email: email,
         body: body,
         isCR: isCR,
         name: name,
         phoneNumber: phoneNumber,
         reportNumber: reportNumber,
      };
      return await this.post(`${CLIENT_ENDPOINT}${SUPPORTNOTIF_ENDPOINT}/new`, reqBody);
   }

   // async getUrlForEvidenceUpload(evidences: File[], reportNumber: string, clientId, s3Bucket, id: string = null) {
   //    const preSignedUrl = [];
   //    for (const evidence of evidences) {
   //       const folder = s3Bucket.isGroup
   //          ? `companies/${clientId}/cd/reports/${reportNumber}/evidences/Denunciado/${id || "anonimo"}`
   //          : `cd/reports/${reportNumber}/evidences/Denunciado/${id || "anonimo"}`;
   //       const body = {
   //          bucket: s3Bucket.bucket,
   //          folder: folder,
   //          name: evidence.name,
   //          appType: evidence.type,
   //       };
   //       preSignedUrl.push(this.post(`${S3_ENDPOINT}/channel/upload`, body));
   //    }
   //    const presignedUrlResults = await Promise.all(preSignedUrl);
   //    if (preSignedUrl.length === 0) throw new Error("document not uploaded");
   //    return presignedUrlResults;
   // }

   async getUrlForEvidenceUpload(evidences: string[], id: string, reportNumber: string) {
      try {
         const folder = `evidences/${reportNumber}/Denunciado/${id || "anonimo"}`;
         const uploadPromises = evidences.map(async (fileKey) => {
            const body = { folder, name: fileKey };
            const { data } = await this.post(`${S3_ENDPOINT}/channel/upload`, body);
            return data;
         });
         const preSignedUrl = await Promise.all(uploadPromises);
         if (!preSignedUrl.length) throw new Error("document not uploaded");
         return preSignedUrl;
      } catch (error) {
         console.error("Error al obtener URLs pre-firmadas:", error);
      }
   }

   async complaintUploadPdfEvidence(signedURL, file) {
      const config = {
         headers: {
            "Content-Type": `${file.type}`,
         },
      };
      axios.defaults.withCredentials = false;
      return await axios.put(signedURL, file, config);
   }

   //UPDATE S3 SERVICE
   async getUrlForS3File(folder: string, fileKey: string) {
      const body = {
         folder: folder,
      };
      const response = await this.put(`${S3_ENDPOINT}/channel/get/${fileKey}`, body);
      return response;
   }
}

export const handleInvalidRequest = (error) => {
   const details: AxiosError = error as AxiosError;
   if (details.response?.data === "expired") {
      console.log("request session expired");
      return null;
   }
   if (details.response?.data === "no user") {
      console.log("request session expired");
      return null;
   }
};
